import React from 'react';

import Loading from '../Common/Loading';
// Types
import { EliqGraphProps } from '../../types/eliq';
// Util
import { loadEliqGraph } from '../../utils/eliqJS';

const EliqGraph: React.FunctionComponent<EliqGraphProps> = (props: EliqGraphProps) => {
  const { token } = props;
  const [showGraph, setShowGraph] = React.useState(false);

  React.useEffect(() => {
    if (token) {
      const showGraph = loadEliqGraph(token);
      setShowGraph(showGraph);
    }
  }, [token]);

  const graph = React.createElement('eliq-insights', { 'ng-version': '11.2.3' });

  // Frustratingly this graph only works when there is a div named container as the parent.
  return (
    <div className="eliq-webcomponents" id="container">
      {!showGraph && <Loading />}
      {showGraph && graph}
    </div>
  );
};

export default EliqGraph;
